<div class="fullscreen-popup">
  
  <div class="popup-content" *ngIf="!isForAgrrment">
    <p>{{ message }}</p>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <!-- <th>#</th> -->
            <th>Tab Name</th>
          </tr>
        </thead>
        <tbody>

          <tr *ngFor="let tab of tabs; let i = index">
            <!-- <td>{{ tab.TabIndex }}</td> -->
            <td   class="link-style"  (click)="onTabClick(tab)"> {{ tab.TabName }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="popup-actions">
      <!-- <button class="popup-btn popup-btn-proceed" (click)="approve()">Proceed</button> -->
      <button class="popup-btn popup-btn-cancel" (click)="close()">Close</button>
    </div>
  </div>
  <div >

    <app-seva-profile-aggrement  *ngIf="isForAgrrment"></app-seva-profile-aggrement>
  </div>


</div>

